import axios from 'axios';
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";

const API_URL = getEnvironment().API_LOGGED_IN_URL + 'global-email-template';

export default class GlobalEmailTemplateService {
    getAll() {
        return axios.get(API_URL + '/list', { headers: authHeader() });
    }

    get(id) {
        return axios.get(API_URL + `/view/${id}`, { headers: authHeader() });
    }

    update(id, data) {
        return axios.put(API_URL + `/update/${id}`, data, { headers: authHeader() });
    }
}

